const namespace = 'template'
export const ns = namespace
export const pfx = ns + '/'
// import { db } from '@/firebase'
// const codebase = db.ref('codebase')

const state = {
}

const getters = {
}

const actions = {
}

const moduleObj = {
  ns,
  pfx,
  namespaced: true,
  state,
  actions,
  getters,
  use,
  clean
}

function use (store) {
  store.registerModule(ns, moduleObj)
}

function clean (store) {
  store.unregisterModule(ns)
}

export default moduleObj



// WEBPACK FOOTER //
// ./src/store/codebase.js